const exportData = () => ({
    data: [],
    dataLength: 0,
    exporting: false,
    minimized: false,
    multiple: false,
});

export default exportData;
